import { useState } from "react";
import { client, useSuspenseQuery } from "../client.ts";

export const fetchConsent = () => client.GET("/consent/status", {});

export function usePollConsentStatusSuspenseQuery() {
    const [isPolling, setIsPolling] = useState(true);
    const query = useSuspenseQuery("get", "/consent/status", undefined, {
        refetchInterval: isPolling ? 2000 : undefined
    });

    if (query.data && query.data.isConsented && isPolling) {
        setIsPolling(false);
    }

    return query;
}
